<div class="d-flex justify-content-center align-items-center">
  <div class="">
    <h2 class="">Page Not Found</h2>
  </div>
</div>
